export const TRANSLATION_COLLABORATORS = {
  hero: {
    title: 'global.collaborators.title',
    description: 'collaborators.hero.description',
    descriptionEmptyState: 'collaborators.hero.description_empty_state',
    labelActivityPill: 'global.insight.week',
    buttonPrimary: 'global.manage_collaborators.main',
    buttonSecondary: 'button.download_collaborators',
    tabs: {
      collaborators: 'global.collaborators.title',
      suscriptionsDeleted: 'collaborators.suscriptions_deleted',
      toAdd: 'global.to_add.main'
    }
  },
  detail: {
    hero: {
      tabs: {
        protection: 'global.health_protection.main',
        benefits: 'global.benefits',
        rent: 'collaborator.rent_details.main',
        balance: 'collaborator.balance.tab'
      }
    },
    joinedAt: 'collaborators.detailsheet.hero.active.description',
    invitedAt: 'collaborators.detailsheet.hero.invited.description',
    formData: {
      title: 'collaborator.rent_details.main',
      labelZipCode: 'global.zip_code.main',
      labelGrossSalary: 'collaborator.rent_details.salary.main',
      labelWorkingHours: 'collaborator.rent_details.hours_worked.main',
      placeHolderGrossSalary: 'collaborator.rent_details.salary.placeholder',
      placeHolderZipCode: 'global.zip_code.placeholder',
      placeHolderWorkingHours: 'collaborator.rent_details.hours_worked.placeholder',
      cancelButton: 'global.cancel.button',
      saveButton: 'global.save_changes.button',
      toast: 'global.save_changes_success.toast',
      errors: {
        moreThan0: 'global.error_hint.number_more_than_0',
        workingHours: 'add_collaborators.error_hint.rf_max_working_hours',
        zipCode: 'global.error_hint.number_5_digits',
        zipCodeFormat: 'add_collaborators.error_hint.rf_zip_code_format'
      }
    },
    collaboratorBalanceRF: {
      currentCycleCard: {
        title: 'collaborator.balance.current_cycle.title',
        empty: {
          title: 'collaborator.balance.current_cycle.empty.title',
          description: 'collaborator.balance.current_cycle.empty.description'
        }
      },
      balanceCard: {
        title: 'collaborator.balance.card.title',
        total: 'collaborator.balance.card.total',
        emptyState: {
          title: 'collaborator.balance.card.empty_state.title',
          description: 'collaborator.balance.card.empty_state.description'
        }
      },
      historyCard: {
        title: 'collaborator.balance.history.title',
        titlePocket: 'collaborator.balance.history.title_pocket',
        titleForecast: 'collaborator.balance.history.title_forecast',
        forecastNote: 'collaborator.balance.history.forecast_note',
        total: 'collaborator.balance.history.total',
        migrated: 'collaborator.balance.history.migrated',
        year: 'collaborator.balance.history.year'
      },
      table: {
        benefit: 'collaborator.balance.table.benefit',
        exempt: 'collaborator.balance.table.exempt',
        nonExempt: 'collaborator.balance.table.non_exempt',
        nonExemptHelp: 'collaborator.balance.table.non_exempt_help',
        total: 'collaborator.balance.table.total'
      },
      empty: {
        title: 'collaborator.balance.empty.title',
        description: 'collaborator.balance.empty.description'
      }
    },
    benefitDetail: {
      coverageMain: 'global.coverage.main',
      validityStart: 'global.validity_start.main',
      seeDetails: 'global.see_details.button',
      loadError: 'global.load_error.main',
      retry: 'csp.retry'
    },
    healthProtection: {
      dependentsCard: {
        title: 'global.family_addon.main',
        description: 'global.family_addon_total.description',
        familyAddon: 'global.add_family_addon.button',
        relationship: {
          partner: 'global.relationship.partner.main',
          child: 'global.relationship.child.main'
        },
        table: {
          linkedCoverage: 'global.linked_coverage.main',
          status: 'global.status',
          validityStart: 'global.validity_start.main',
          insuranceCompany: 'global.insurance_company.main',
          pending: 'status.pending',
          pendingTooltip: 'global.validity_date.pending.tooltip'
        },
        emptyState: {
          title: 'collaborators.detailsheet.family_addon.empty_state.title',
          description: 'collaborators.detailsheet.family_addon.empty_state.description'
        },
        addDependentsTooltip: 'add_family_addon.mexico.temporal_disabled.tooltip'
      }
    },
    novation: {
      downloadButton: 'global.novation_agreement.main',
      tooltipMessage: 'rf.novation_agreement.not_available.description'
    },
    certificate: {
      notFoundModal: {
        title: 'download_insurance_certificate.méxico.error_not_found.dialog.title',
        description: 'download_insurance_certificate.méxico.error_not_found.dialog.description',
        close: 'button.close',
        contactSupport: 'global.button.contact_support'
      },
      downloadButton: 'global.insurance_certificate.main'
    }
  },
  table: {
    headers: {
      email: 'global.email.main',
      identification: 'global.id.main',
      status: 'global.onboarding_status.main',
      plan: 'global.plan.main',
      onboardingDate: 'global.onboarding_date.main',
      name: 'global.name.main',
      eliminationDate: 'global.elimination_date.main',
      eliminationAuthor: 'global.elimination_author.main',
      location: 'collaborators.global.work_location',
      hiringDate: 'collaborators.global.hiring_date'
    },
    noResults: {
      title: 'global.search.no_results.title',
      description: 'global.search.no_results.description'
    },
    emptyData: {
      activeTable: {
        title: 'metrics.collaborators_card.empty_state.title',
        description: 'metrics.collaborators_card.empty_state.description',
        button: 'button.add_collaborators'
      },
      deletedTable: {
        title: 'collaborators.deleted_suscriptions.empty_state.title',
        description: 'collaborators.deleted_suscriptions.empty_state.description'
      },
      toAddTable: {
        title: 'collaborators.to_add.empty_state.title',
        description: 'collaborators.to_add.empty_state.description'
      }
    },
    menu: {
      deleteSubscription: 'collaborators.action.delete_suscription',
      resendEmailLabel: 'collaborators.action_title.reinvite',
      resendEmail: 'collaborators.action.send_email',
      novation: {
        documents: 'global.documents.main',
        main: 'global.novation_agreement.main',
        agreementNotAvailable: 'rf.novation_agreement.not_available.description',
        loadingModal: 'global.download_document.loading.description'
      },
      insuranceCertificate: {
        documents: 'global.documents.main',
        main: 'global.insurance_certificate.main'
      }
    },
    deleteModal: {
      title: 'delete_suscription.dialog.title',
      description: 'delete_suscription.dialog.description',
      buttonClose: 'button.close',
      buttonConfirm: 'global.confirmation.delete',
      plural: {
        title: 'delete_suscriptions.dialog.title',
        description: 'delete_suscriptions.dialog.description'
      }
    },
    resendEmailModal: {
      title: 'send_email.dialog.title',
      description: 'send_email.dialog.description',
      buttonSend: 'global.button.send_email',
      disclaimer: 'send_email.dialog.disclaimer',
      plural: {
        title: 'send_emails.dialog.title',
        description: 'send_emails.dialog.description',
        disclaimer: 'send_emails.dialog.disclaimer'
      }
    },
    toasts: {
      deleteCollaborator: {
        title: 'delete_suscription.toast.success'
      },
      resendEmail: {
        title: 'send_email.toast.success'
      },
      error: {
        title: 'global.toast.error.title',
        description: 'global.toast.error.description'
      }
    },
    tooltips: {
      addCollaborator: 'global.add_collaborator.main',
      deleteCollaborator: 'collaborators.action.delete_suscription',
      deletePending: 'global.delete_from_list.main',
      resendEmail: 'collaborators.action_title.reinvite',
      pendingCollaborator: 'collaborators.status_pending.tooltip'
    },
    detail: {
      hero: {
        tabs: {
          protection: 'global.health_protection.main',
          benefits: 'global.benefits',
          rent: 'collaborator.rent_details.main'
        }
      },
      joinedAt: 'collaborators.detailsheet.hero.active.description',
      invitedAt: 'collaborators.detailsheet.hero.invited.description',
      benefits: 'global.benefits',
      empty_state: {
        title: 'collaborators.detailsheet.empty_state.title',
        description: 'collaborators.detailsheet.empty_state.description'
      },
      unselectedBenefits: {
        title: 'home.ranking_card.empty_state.title',
        description: 'home.ranking_card.empty_state.description'
      }
    },
    toAddInfoBanner: {
      body: 'collaborators.to_add.info_banner.body',
      date: 'global.last_sync.main'
    },
    filterAll: 'global.label.all',
    filterActive: 'status.active',
    filterInvited: 'status.invited',
    titleGenericMenu: 'collaborators.filter_menu.title',
    buttonFilter: 'global.button.filter',
    searchBarPlaceholder: 'search.placeholder.email_name_id',
    searchBarPlaceholderUnsubscriptions: 'search.placeholder.email_name',
    searchBarPlaceholderToAdd: 'search.placeholder.email_name',
    actionBar: 'global.action_bar.selected_items'
  },
  toAdd: {
    infoBanner: 'collaborators.to_add.info_banner.body',
    lastSync: 'global.last_sync.main',
    buttonDownload: 'button.download'
  },
  toast: {
    successAddCollaborator: {
      title: 'add_colaborator.toast.success.title',
      subtitle: 'add_colaborator.toast.success.description'
    },
    successDeleteCollaborator: {
      title: 'global.delete_from_list.toast.success'
    },
    errorCollaboratorLimit: {
      title: 'delete_suscriptions.time_out.toast.title',
      subtitle: 'delete_suscriptions.time_out.toast.description'
    },
    errorAddCollaborator: {
      title: 'global.delete_from_list.toast.success'
    }
  },
  modal: {
    addCollaborators: {
      title: 'global.add_collaborator.main',
      description: 'collaborators.add_collaborator.dialog.description',
      button: 'global.add_collaborator.main',
      titleSelectPlan: 'add_collaborator.select_plan.title',
      selectPlanPlaceHolder: 'add_collaborator.select_plan.input.placeholder',
      pendingDialogTitle: 'collaborators.add_collaborators.dialog_success_pending.title',
      pendingDialogDescription: 'collaborators.add_collaborators.dialog_success_pending.description',
      dialogTitle: 'collaborators.add_collaborators.dialog_success.title',
      dialogDescription: 'collaborators.add_collaborators.dialog_success.description',
      buttonEnd: 'global.button.end',
      buttonNext: 'global.button.next',
      dependents: {
        title: 'add_family_addons.invitation.dialog.title',
        description: 'add_family_addons.global.invitation.description',
        button: 'global.add_family_addon.button'
      }
    },
    deleteCollaborators: {
      title: 'global.delete_from_list.main',
      description: 'global.delete_from_list.dialog.description',
      cancelButton: 'button.close',
      confirmButton: 'global.confirmation.delete'
    },
    sendMembersEmailModal: {
      title: 'download_collaborators.dialog.title',
      description: 'download_collaborators.dialog.description',
      button: 'button.understood'
    },
    addDependents: {
      title: 'add_family_addon.success.dialog.title',
      description: 'add_family_addon.success.dialog.description',
      button: 'global.button.end'
    }
  }
};

export const CERTIFICATE_TYPE_TRANSLATIONS: { [key: string]: string } = {
  GMM: 'global.mme_insurance_certificate.main',
  AP: 'global.anh_insurance_certificate.main',
  VIDA: 'global.life_insurance_certificate.main'
};

export const TRANSLATIONS_COLLABORATOR_STATUS: { [key: string]: string } = {
  all: 'csp.all',
  active: 'csp.active',
  inactive: 'csp.inactive',
  invited: 'csp.invited',
  in_progress: 'csp.in_progress'
};

export const TRANSLATIONS_COLLABORATOR_STATUS_V3: { [key: string]: string } = {
  all: 'global.label.all',
  active: 'status.active',
  invited: 'status.invited',
  in_progress: 'status.processing',
  pending: 'status.pending'
};

export const TRANSLATIONS_COLLABORATOR_GENDER: { [key: string]: string } = {
  m: 'csp.gender.male',
  f: 'csp.gender.female',
  o: 'csp.gender.other'
};
